import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getOrders = (params) => httpClient.get(`${ENDPOINT_API.ORDERS}`, { params });
const getOrder = (id) => httpClient.get(`${ENDPOINT_API.ORDERS}/${id}`);
const getOrderDoc = (id, params) => httpClient.get(`${ENDPOINT_API.ORDERS}/${id}/document`, { params });
const postOrderDocMultiple = (params) => httpClient.post(`${ENDPOINT_API.ORDERS}/batch-document`, params);
const postOrderStatus = (id) => httpClient.post(`${ENDPOINT_API.ORDERS}/${id}/ready-to-ship`);
const postOrderStatusMultiple = (params) => httpClient.post(`${ENDPOINT_API.ORDERS}/multiple-ready-to-ship`, params);
const postReconcileStatus = (id) => httpClient.post(`${ENDPOINT_API.ORDERS}/${id}/reconcile`);

export {
	getOrders,
	getOrder,
	getOrderDoc,
	postOrderDocMultiple,
	postOrderStatus,
	postOrderStatusMultiple,
	postReconcileStatus,
};
